import { useBackendApi } from "./backendApi";
import { useCacheService } from './cacheService';

export interface ExternalUserDto {
  id: string;
  name: string;
  email: string;
  connectionProfileId: number;
}

export function useExternalUsersService() {

  const backendApi = useBackendApi();

  const cacheService = useCacheService('externalUsers');

  const getAllExternalUsers = async (connectionProfileId: number) => {
    return cacheService.get(`externalUsers-${connectionProfileId}`, async (cacheItem  ) => {
      cacheItem.setExpireInSeconds(60);
      return await backendApi.get(`/integrations/profiles/${connectionProfileId}/users`) as ExternalUserDto[];
    })

  }

  return {
    getAllExternalUsers,
  }
}
